import { render, staticRenderFns } from "./RelatedCombos.vue?vue&type=template&id=574f550c"
import script from "./RelatedCombos.vue?vue&type=script&lang=js"
export * from "./RelatedCombos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports